import finaly from './finaly';
import addEvent from './addEvent';

export default {
    ...finaly,
    ...addEvent,
};
